import * as React from 'react'
import { ColumnOption } from './types'
import OptionRow from './option_row'
import useDropdownOptions from './use_dropdown_options'
import I18n from '../../../libs/i18n'

interface DropdownOptionsEditorProps {
  options: ColumnOption[]
  onChange: (options: ColumnOption[]) => void
  generateOptionId: () => string
}

export default function DropdownOptionsEditor({
  options,
  onChange,
  generateOptionId,
}: DropdownOptionsEditorProps) {
  const {
    visibleOptions,
    moveOption,
    updateOption,
    removeOption,
    addOption,
  } = useDropdownOptions({ options, onChange, generateOptionId })

  return (
    <div className="dropdown-options-editor mt-2 ml-4 p-2 border rounded bg-light">
      <label className="small text-muted mb-2">{I18n.t('project_groups.columns_editor.dropdown_options')}</label>
      {visibleOptions.map((option, index) => (
        <OptionRow
          key={option.id}
          option={option}
          index={index}
          moveOption={moveOption}
          updateOption={updateOption}
          removeOption={removeOption}
        />
      ))}
      <button
        type="button"
        className="btn btn-outline-secondary btn-sm"
        onClick={addOption}
      >
        <i className="fa fa-plus mr-1" />
        {I18n.t('project_groups.columns_editor.add_option')}
      </button>
    </div>
  )
}
